<div class="page-container">
  <div class="header-minimal">
    <img src="assets/img/Logo-river-app.svg" alt="Logo" class="logo" />
  </div>

  <div class="overlay" *ngIf="isLogin">
    <div class="loading-container">
      <div class="spinner"></div>
    </div>
  </div>

  <div class="modal-overlay">
    <div class="modal-container">
      <div class="modal-header">
        <div class="header-content">
          <h2 class="modal-title">Recuperar contraseña</h2>
          <button
            class="close-button"
            (click)="navigateToLogin()"
            type="button"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>

      <form
        [formGroup]="recoverPass"
        (ngSubmit)="recoverPassword()"
        class="modal-form"
      >
        <div class="form-group">
          <label for="password" class="form-label">Nueva contraseña</label>
          <div class="input-container">
            <input
              id="password"
              formControlName="password"
              [type]="showPassword ? 'password' : 'text'"
              class="form-input"
              [class.error]="
                recoverPass.get('password')?.invalid &&
                recoverPass.get('password')?.touched
              "
              placeholder="Contraseña"
            />
            <button
              type="button"
              class="password-toggle"
              (click)="togglePasswordVisibility()"
            >
              <svg
                *ngIf="!showPassword"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                  stroke="currentColor"
                  stroke-width="2"
                  fill="none"
                />
                <circle
                  cx="12"
                  cy="12"
                  r="3"
                  stroke="currentColor"
                  stroke-width="2"
                  fill="none"
                />
              </svg>
              <svg
                *ngIf="showPassword"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
                  stroke="currentColor"
                  stroke-width="2"
                  fill="none"
                />
                <line
                  x1="1"
                  y1="1"
                  x2="23"
                  y2="23"
                  stroke="currentColor"
                  stroke-width="2"
                />
              </svg>
            </button>
          </div>
          <div
            class="validation-text"
            *ngIf="
              recoverPass.get('password')?.invalid &&
              recoverPass.get('password')?.touched
            "
          >
            {{ getErrorMessage("password") }}
          </div>
        </div>

        <div class="form-group">
          <label for="confirmPassword" class="form-label"
            >Confirmar nueva contraseña</label
          >
          <div class="input-container">
            <input
              id="confirmPassword"
              formControlName="confirmPassword"
              [type]="showConfirmPassword ? 'password' : 'text'"
              class="form-input"
              [class.error]="
                recoverPass.get('confirmPassword')?.invalid &&
                recoverPass.get('confirmPassword')?.touched
              "
              placeholder="Contraseña"
            />
            <button
              type="button"
              class="password-toggle"
              (click)="toggleConfirmPasswordVisibility()"
            >
              <svg
                *ngIf="!showConfirmPassword"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                  stroke="currentColor"
                  stroke-width="2"
                  fill="none"
                />
                <circle
                  cx="12"
                  cy="12"
                  r="3"
                  stroke="currentColor"
                  stroke-width="2"
                  fill="none"
                />
              </svg>
              <svg
                *ngIf="showConfirmPassword"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
                  stroke="currentColor"
                  stroke-width="2"
                  fill="none"
                />
                <line
                  x1="1"
                  y1="1"
                  x2="23"
                  y2="23"
                  stroke="currentColor"
                  stroke-width="2"
                />
              </svg>
            </button>
          </div>
          <div
            class="validation-text error"
            *ngIf="
              recoverPass.get('confirmPassword')?.invalid &&
              recoverPass.get('confirmPassword')?.touched
            "
          >
            {{ getErrorMessage("confirmPassword") }}
          </div>
        </div>

        <div class="bottom-bar">
          <button
            type="submit"
            class="submit-button"
            [disabled]="
              !recoverPass.valid || isLogin || arePasswordFieldsEmpty()
            "
          >
            Continuar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
